import { render, staticRenderFns } from "./SVGArrowDown.vue?vue&type=template&id=4de665a4&scoped=true&"
import script from "./SVGArrowDown.vue?vue&type=script&lang=js&"
export * from "./SVGArrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de665a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de665a4')) {
      api.createRecord('4de665a4', component.options)
    } else {
      api.reload('4de665a4', component.options)
    }
    module.hot.accept("./SVGArrowDown.vue?vue&type=template&id=4de665a4&scoped=true&", function () {
      api.rerender('4de665a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGArrowDown.vue"
export default component.exports